<i18n src="@/locales/models/estimated_harvest.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/organization/projections/query_estimated_harvest/show_harvest_process.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-6">
    <h1 class="page-title">
      <i class="fa-solid fa-apple-crate"></i><span class="space-icon"></span
      >{{ $t("labels.estimated_harvests_title") }}
    </h1>
    <div class="flex flex-row justify-between">
      <div class="panel-plain-label space-x-4">
        <!-- <badge-default
          :label="
            estimated_harvests.length +
            ' ' +
            $t('labels.total_number_estimated_harvests')
          "
        /> -->
      </div>
    </div>
    <div class="mt-8 flex flex-col">
      <ag-grid-vue
        v-if="estimated_harvests.length > 0"
        style="width: 100%; height: 600px"
        class="ag-theme-alpine w-full h-full"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="estimated_harvests_modified"
      ></ag-grid-vue>
    </div>
  </div>
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";

export default {
  name: "ShowHarvestProcessEstimatedHarvests",
  components: { AgGridVue },
  data() {
    return {
      defaultColDef: {
        sortable: true,
        filter: true,
        floatingFilter: true
      },
      columnDefs: [
        {
          headerName: this.$t("model.estimated_harvest.week"),
          field: "week",
          filter: "agNumberColumnFilter",
          width: 50
        },
        {
          headerName: this.$t(
            "model.producer.organization_producer.producer_code"
          ),
          field: "producer.org_producer_code"
        },
        {
          headerName: this.$t("model.estimated_harvest.producer"),
          field: "producer.fullname",
          width: 300
        },
        {
          headerName: this.$t(
            "model.crop_field.organization_crop_field.crop_field_code"
          ),
          field: "crop_field.org_crop_field_code"
        },
        {
          headerName: this.$t("model.estimated_harvest.crop_field"),
          field: "crop_field.name"
        },
        ...this.displayCropFieldSector(),
        {
          headerName: this.$t("model.estimated_harvest.num_packages"),
          field: "num_packages",
          filter: "agNumberColumnFilter",
          cellRenderer: params => {
            return `${this.numberWithPrecision(params.value)} ${
              params.data.harvest_process_crop_package.name
            }s`;
          }
        },
        ...this.harvest_process_crop_size_groups.map(
          harvest_process_crop_size_group => {
            return {
              headerName: harvest_process_crop_size_group.name + " (%)",
              field: `${harvest_process_crop_size_group.id}`,
              filter: "agNumberColumnFilter"
            };
          }
        )
      ]
    };
  },
  props: {
    estimated_harvests: {
      type: Array,
      required: true
    },
    harvest_process_crop_size_groups: {
      type: Array,
      required: true
    }
  },
  computed: {
    estimated_harvests_modified: function () {
      return this.estimated_harvests.map(estimated_harvest => {
        let estimated_harvest_groups = {};
        this.harvest_process_crop_size_groups.forEach(
          harvest_process_crop_size_group => {
            estimated_harvest_groups[harvest_process_crop_size_group.id] =
              estimated_harvest.estimated_harvest_groups.find(
                ehg =>
                  ehg.harvest_process_crop_size_group_id ==
                  harvest_process_crop_size_group.id
              )?.percent || "";
          }
        );
        return {
          ...estimated_harvest,
          ...estimated_harvest_groups
        };
      });
    }
  },
  methods: {
    displayCropFieldSector: function () {
      let crop_field_sectors = this.estimated_harvests
        .map(estimated_harvest => estimated_harvest.crop_field_sector?.name)
        .filter(
          (v, i, a) => v !== undefined && v !== null && a.indexOf(v) === i
        );

      if (crop_field_sectors.length > 1) {
        return [
          {
            headerName: this.$t("model.estimated_harvest.crop_field_sector"),
            field: "crop_field_sector.name"
          }
        ];
      } else return [];
    },
    sizeToFit() {
      this.gridApi.sizeColumnsToFit({
        defaultMinWidth: 150
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.sizeToFit();
    }
  }
};
</script>
